import {createContext} from 'react';
import {User, HexosparkUser} from './../types';

export const UserContext = createContext({
  user: null as null | User,
  setUser: (user: User | null) => {},
  hexosparkUser: null as HexosparkUser | null,
  setHexosparkUser: (hexosparkUser: HexosparkUser | null) => {},
});
